import React from 'react';

import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface VirtualDigestTabLegendItem {
  index: string;
  title: string;
}

export interface VirtualDigestTabProps {
  legend: Array<VirtualDigestTabLegendItem>;
}

function VirtualDigestTab({legend}: VirtualDigestTabProps): JSX.Element {
  return (
    <div className="container">
      <div className="row">
        <div className="col col-md-12">
          <dl className="dl-horizontal highlighted">
            <dt>Highlighted Fragment</dt>
            <dd>--</dd>
          </dl>
        </div>
      </div>
      <div className="row">
        <div className="col col-md-12">
          <dl className="dl-horizontal legend">
            {legend.map((item) => (
              <React.Fragment key={item.index}>
                <dt>{item.index}</dt>
                <dd>{item.title}</dd>
              </React.Fragment>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<VirtualDigestTabProps>(VirtualDigestTab);
